import {
  Box,
  Container,
  Heading,
  HStack,
  IconButton,
  Image,
} from '@chakra-ui/react';
import { FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

import { usePageHeader } from '#src/providers/page-layout-provider';
import { useSidebar } from '#src/providers/sidebar-provider';

export function PageHeader() {
  const { title, actionsRef } = usePageHeader();
  const { onOpen } = useSidebar();
  const navigate = useNavigate();

  return (
    <Box
      position="sticky"
      top={0}
      zIndex={10}
      bg="var(--background-base-color)"
      shadow="none"
      borderBottomWidth="var(--border-base-width)"
      borderColor="var(--border-base-color)"
      mb={0}
      width="100%"
    >
      <Container maxW="7xl" px={4} py={3}>
        <HStack justify="space-between" align="center" gap={4}>
          <HStack gap={3} align="center" flex={1} minW={0}>
            {/* Site logo — toggles sidebar */}
            <Image
              src="/icon.svg"
              alt="Open navigation menu"
              height="32px"
              width="32px"
              cursor="pointer"
              onClick={onOpen}
              flexShrink={0}
            />

            <IconButton
              type="button"
              variant="ghost"
              size="sm"
              aria-label="Go back"
              flexShrink={0}
              onClick={() => navigate(-1)}
            >
              <FiArrowLeft size={20} aria-hidden />
            </IconButton>

            {/* Title */}
            {title != null && (
              <Heading size="lg" color="fg" flex={1} minW={0}>
                {typeof title === 'string' ? title : title}
              </Heading>
            )}
          </HStack>

          {/* Portal target for page actions */}
          <Box ref={actionsRef} flexShrink={0} />
        </HStack>
      </Container>
    </Box>
  );
}
